import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { ModulesFacade } from '@app/store/modules';
import { Module } from '@app/store/shared/models';
import { DialogSearchComponent } from '../shared/dialog-search/dialog-search.component';
import { ModuleSelectionService } from './module-selection.service';

@Component({
    selector: 'app-select-module-dialog',
    templateUrl: './select-module.component.html',
    styleUrls: ['./select-module.component.css'],
    imports: [TranslateModule, RouterLink, ButtonModule, PaginatorModule, DialogSearchComponent],
})
export class SelectModuleComponent implements OnInit, OnDestroy {
    private readonly router = inject(Router);
    private readonly translateService = inject(TranslateService);
    private readonly modulesFacade = inject(ModulesFacade);
    private readonly moduleSelectionService = inject(ModuleSelectionService);

    readonly items = this.modulesFacade.modules;
    readonly total = this.modulesFacade.total;
    readonly loading = this.modulesFacade.loading;
    readonly limit = 10;
    readonly first = signal(0);
    readonly searchValue = signal('');

    readonly searchPlaceholder = this.translateService.instant('courses.modules.dialog.search');

    ngOnInit(): void {
        this.loadModules();
    }

    ngOnDestroy(): void {
        this.modulesFacade.clear();
    }

    onSearch(search: string): void {
        this.searchValue.set(search);
        this.first.set(0);
        this.loadModules();
    }

    selectModule(module: Module): void {
        this.moduleSelectionService.select({ id: module.id, name: module.name });
        this.close();
    }

    onPageChange(event: PaginatorState): void {
        const first = event.first ?? 0;
        this.first.set(first);
        const page = Math.floor(first / this.limit) + 1;
        this.loadModules(page);
    }

    loadModules(page = 1): void {
        this.modulesFacade.getModules({ page, limit: this.limit, search: this.searchValue() || undefined });
    }

    close(): void {
        this.router.navigate([{ outlets: { dialog: null } }]);
    }
}
